import React, { memo } from 'react';

import HelpIcon from '@mui/icons-material/Help';
import { Box, Button, Tooltip, Typography } from '@mui/material';

const styles = {
  footerArea: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '0 1 auto',
  },
  button: {
    padding: '0px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
  },
} as const;

interface ViewDetailsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  strings: {
    viewDetails: string;
    tooltipInfo: string;
  };
}

export const ViewDetailsButton: React.FC<ViewDetailsButtonProps> = memo(({ strings, onClick }) => {
  return (
    <Box sx={styles.footerArea}>
      <Button variant="text" onClick={onClick} sx={styles.button}>
        {strings.viewDetails}
      </Button>
      <Tooltip
        title={<Typography variant="inherit">{strings.tooltipInfo}</Typography>}
        arrow
        placement="bottom-end"
      >
        <HelpIcon />
      </Tooltip>
    </Box>
  );
});
